import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {flex, mb, ml, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

export interface IPropertyDetailTag {
    icon: React.ReactNode;
    label: string;
    value: string;
}

export const PropertyDetailTag = ({icon, label, value}: IPropertyDetailTag) => {
    const theme = useTheme();
    return (
        <div css={propertyTag}>
            {icon}

            <div css={tagData}>
                <Text color={theme.colors.gray[700]} variant="body_copy_2">
                    {label}
                </Text>
                <Text as="div" variant="headline_6" strong>
                    {value}
                </Text>
            </div>
        </div>
    );
};

const propertyTag = (theme: Theme) => css`
    display: flex;
    align-items: center;

    @media (max-width: ${theme.breakpoints.md}) {
        ${mb(6)};
        ${p(0)};

        &:last-of-type {
            ${mb(0)};
        }
    }
`;

const tagData = css`
    ${flex()};
    flex-direction: column;
    ${ml()};
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {flex, mb, ml, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

export interface IPropertyDetailTag {
    icon: React.ReactNode;
    label: string;
    value: string;
}

export const PropertyDetailTag = ({icon, label, value}: IPropertyDetailTag) => {
    const theme = useTheme();
    return (
        <div css={propertyTag}>
            {icon}

            <div css={tagData}>
                <Text color={theme.colors.gray[700]} variant="body_copy_2">
                    {label}
                </Text>
                <Text as="div" variant="headline_6" strong>
                    {value}
                </Text>
            </div>
        </div>
    );
};

const propertyTag = (theme: Theme) => css`
    display: flex;
    align-items: center;

    @media (max-width: ${theme.breakpoints.md}) {
        ${mb(6)};
        ${p(0)};

        &:last-of-type {
            ${mb(0)};
        }
    }
`;

const tagData = css`
    ${flex()};
    flex-direction: column;
    ${ml()};
`;
